<template>
  <PageTableLayout
    :items="contacts"
    :is-loading="isLoading"
    :current-page="currentPage"
    :total-pages="totalPages"
    :total-records="totalRecords"
    :records-per-page="recordsPerPage"
    :show-pagination="true"
    :show-search-action-button="false"
    :no-records-message="'No records found'"
    :no-records-button-label="'Create New Contact'"
    :no-records-button-action="goToCreateContact"
    :show-search-filters="false"
    @records-per-page-changed="onChangeRecordsPerPage"
    @pagechanged="onPageChange"
  >
    <template #content="{ items }">
      <ContactsTable :rows="items" :is-loading="isLoading"/>
    </template>
  </PageTableLayout>
</template>

<script>

import PageTableLayout from "../layouts/PageTableLayout.vue";
import contactService from "../../service/contact.service";
import {handleError} from "../../utils/notification.utils";
import ContactsTable from "./ContactsTable.vue";
import NoRecordsFound from "../shared/NoRecordsFound.vue";

export default {
  components: {
    PageTableLayout,
    ContactsTable,
    NoRecordsFound
  },
  data() {
    return {
      customerId: this.$route.params.id || null,
      contacts: [],
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
      recordsPerPage: 12,
      isLoading: true,
      lastAppliedFilters: {}
    };
  },
  methods: {
    goToCreateContact() {
      this.$router.push('/contacts/create');
    },
    retrieveContacts(filters = {}) {
      this.isLoading = true;
      this.lastAppliedFilters = filters;
      
      let params = {
        page: this.currentPage,
        size: this.recordsPerPage,
        merchantId: localStorage.getItem('mid'),
        sort: 'firstName,-lastName',
        status_in: 'ACTIVE,PENDING',
        createdAt_between: '2000-01-01,3024-12-31',
        deletedAt_null: true,
      }

      // Apply filters from the drawer
      Object.entries(filters).forEach(([key, value]) => {
        if (value && value.trim() !== '') {
          params[key] = value.trim();
        }
      });

      contactService.find(localStorage.getItem('mid'), params)
        .then(response => {
          this.contacts = response.data.data;
          this.totalPages = response.data.pagination ? response.data.pagination.totalPages : 0;
          this.totalRecords = response.data.pagination ? response.data.pagination.totalRecords : 0;
        })
        .catch(handleError)
        .finally(() => {
          this.isLoading = false;
        });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.retrieveContacts(this.lastAppliedFilters);
    },
    onChangeRecordsPerPage(recordsPerPage) {
      this.recordsPerPage = recordsPerPage;
      this.currentPage = 1; // Reset to first page when changing page size
      this.retrieveContacts(this.lastAppliedFilters);
    },
    loadInitialData() {
      this.retrieveContacts({});
    }
  },
  mounted() {
    this.loadInitialData();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contacts/ContactsPageBody.vue